import { AD8_ANSWERS } from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  ownCoding,
  scoreBand,
  scoredItem,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'items',
    title: 'AD8 Screening',
    items: [
      [
        'judgment',
        'Problems with judgment (e.g., problems making decisions, bad financial decisions, problems with thinking)',
      ],
      ['hobbies', 'Less interest in hobbies/activities'],
      [
        'repeats',
        'Repeats the same things over and over (questions, stories, or statements)',
      ],
      [
        'learning-tools',
        'Trouble learning how to use a tool, appliance, or gadget (e.g., VCR, computer, microwave, remote control)',
      ],
      ['month-year', 'Forgets correct month or year'],
      [
        'finances',
        'Trouble handling complicated financial affairs (e.g., balancing checkbook, income taxes, paying bills)',
      ],
      ['appointments', 'Trouble remembering appointments'],
      ['daily-problems', 'Daily problems with thinking and/or memory'],
    ].map(([item, label]) =>
      scoredItem(ownCoding(`ad8-${item}`, label), AD8_ANSWERS)
    ),
  },
]

// "N/A, don't know" scores 0 and answers its item, so the total counts the
// "Yes, a change" answers and an N/A never holds it back.
export const AD8_TEMPLATE: InstrumentTemplate = {
  id: 'ad8',
  version: '1',
  panel: ownCoding('ad8-panel', 'AD8 dementia screening'),
  title: 'AD8 Dementia Screening Interview',
  shortName: 'AD8',
  reference:
    'https://www.alz.org/getmedia/6e7291bf-4ac8-40ed-a148-824d4591ed7e/ad8-dementia-screening.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'ad8',
    coding: ownCoding('ad8-total', 'AD8 total score'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand({ min: 0, max: 1 }, 'ad8-normal', 'Normal Cognition', 'green'),
      scoreBand(
        { min: 2 },
        'ad8-impaired',
        'Cognitive Impairment Likely',
        'red'
      ),
    ],
  }),
}
